import { InputSkeleton } from '@/_components';
import {
  CardContainer,
  Container,
  ContainerLayout,
  FormLayout,
  LeftSection,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';

export default function Loading() {
  return (
    <ContainerLayout>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} withBreadcrumb />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
              <InputSkeleton className="col-span-12 sm:col-span-6 lg:col-span-4" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </ContainerLayout>
  );
}
